import './App.css';
import AddProduct from './components/AddProduct';
import ProductList from './components/ProductList';
import { useState } from 'react'

function App() {

  const data = [
    { id: 1, name: 'Велосипед', price: 1000, count: 1 },
    { id: 2, name: 'Самокат', price: 700, count: 1 },
    { id: 3, name: 'Ролики', price: 1300, count: 2 },
    { id: 4, name: 'Сноуборд', price: 19000, count: 4 },
    { id: 5, name: 'Перчатки', price: 7000, count: 23 }
  ]

  const [product, setProduct] = useState(data)

  // #1
  function addProduct() {
    let [name, price] = prompt().split(' ')
    let newProduct = {
      id: Date.now(),
      name: name,
      price: price,
      count: 1,
    }
    setProduct([...product, newProduct])
    console.log(newProduct)
  }

  // #2
  function incrCount(id) {
    let getCount = product.map(elem => {
      if (elem.id === id && elem.count < 25) {
        elem.count += 1
      }
      return elem
    })
    setProduct(getCount)
    console.log(getCount)
  }

  function decrCount(id) {
    let deleteElem = false
    let getCount = product.filter(elem => {
      if (elem.id === id) {
        if (elem.count > 1) {
          elem.count -= 1;
        }
        else if (elem.count === 1) {
          deleteElem = true
        }
      }
      return elem
    });

    if (deleteElem) {
      getCount = product.filter((elem => elem.id !== id))
    }

    setProduct(getCount)
    console.log(getCount)
  }

  // #3
  function delProduct(id) {
    let deletedProduct = product.filter((elem => elem.id !== id))
    setProduct(deletedProduct)
    console.log(deletedProduct)
  }

  return (
    <div className="App">
      <AddProduct addProduct={addProduct}/>
      <ProductList 
        product={product}
        incrCount={incrCount}
        decrCount={decrCount}
        delProduct={delProduct}
      />
    </div>
  );
}

export default App;
